import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import reducers from './reducers';

export const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredPaths: ['user.value.info.profile.telegram.id', 'user.value.info.profile.telegram.id'],
                ignoredActionPaths: ['payload.info.profile.telegram.id', 'payload.profile.telegram.id'],

                isSerializable: (value: unknown) => typeof value !== 'bigint',
            },
        }).concat(),
});

setupListeners(store.dispatch);
export type TRootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
